module.exports = __webpack_public_path__ + "img/new-ranks-element-2.a948ad7c.png";